import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { useSubmitViaKeyboard } from "@circle-react/hooks/utils/useSubmitViaKeyboard";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";
import { RichTextInput } from "@circle-react-uikit/RichTextInput";

export const Content = ({ spaceId, spaceIsPrivate, onClose }) => {
  const {
    watch,
    formState: { isDirty, isSubmitting, isSubmitSuccessful },
  } = useFormContext();
  const { body } = watch();
  const isLoading = isSubmitting || isSubmitSuccessful;
  const submitEnabled = !!body && !isLoading;

  useSubmitViaKeyboard({ enabled: submitEnabled });

  const onCloseWithConfirm = () => {
    if (!isDirty || confirm(t("prevent_accidental_leave_message"))) {
      onClose();
    }
  };

  // `overflow-visible` ensures that toolbars, e.g. the emoji picker, aren't getting cut off.
  // `transform-none` disables in/out transitions to fix issues with Trix toolbar positioning.
  return (
    <Modal.Content
      size="lg"
      wrapperClassName="!h-full"
      className="!transform-none !overflow-visible"
    >
      <Modal.Header>
        <Modal.Title>{t("comments.edit.form.title")}</Modal.Title>
        <Modal.HeaderActions>
          <Modal.CloseButton onClick={onCloseWithConfirm} />
        </Modal.HeaderActions>
      </Modal.Header>
      <Modal.Body className="comment__edit-modal-content-body trix-v2 max-h-[calc(100dvh-82px-65px)] !overflow-visible md:max-h-none">
        <RichTextInput
          id="comment-edit-body"
          name="body"
          placeholder={t("comments.form.fields.body_placeholder")}
          className="h-full"
          editorContainerClassName="flex flex-col h-full"
          textboxClassName="overflow-auto rounded-md py-4 sm:max-h-[40vh]"
          space_id={spaceId}
          is_private_space={spaceIsPrivate}
        />
      </Modal.Body>
      <Modal.Footer className="bottom-0 flex justify-end space-x-4">
        <Button type="button" variant="secondary" onClick={onCloseWithConfirm}>
          {t("cancel")}
        </Button>
        <Button type="submit" variant="primary" disabled={!submitEnabled}>
          {isLoading ? t("saving_changes") : t("save_changes")}
        </Button>
      </Modal.Footer>
    </Modal.Content>
  );
};

Content.propTypes = {
  spaceId: PropTypes.number.isRequired,
  spaceIsPrivate: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
